import { Button, Col, Modal, ModalBody, ModalHeader, Row } from 'react-bootstrap';
import marketSignalApi from '@/modules/market-signals/api/market-signal-api';
import { useContext, useEffect, useState } from 'react';
import MarketSignalScrollerEntry from '@/modules/market-signals/components/market-signals/scroller/market-signal-scroller-entry';
import { Loading } from '@/shared/components/export';
import { MarketSignalStreamAnalysisTopic } from '@/modules/market-signals/model/market-signals/market-signal-stream-analysis';
import { Page } from '@/shared/pagination/export';
import { MarketSignal } from '@/modules/market-signals/model/market-signals/market-signal';
import { MarketSignalContext } from '@/modules/market-signals/contexts/market-signal-context';

export default function MarketSignalTopicModal({
  topic,
  onClose,
  onTriggerQuestion,
}: {
  topic?: MarketSignalStreamAnalysisTopic;
  onClose: () => void;
  onTriggerQuestion: (s: string) => void;
}) {
  const [loading, setLoading] = useState<boolean>(false);
  const [sources, setSources] = useState<Page<MarketSignal>>();

  const { alarms, acknowledgeAlarms } = useContext(MarketSignalContext);

  useEffect(() => {
    if (!topic) return;

    setSources(undefined);
    setLoading(true);

    marketSignalApi
      .getSignalsByIds(topic.ids)
      .then(setSources)
      .finally(() => setLoading(false));
  }, [topic]);

  const close = () => {
    if (topic) {
      const alarmsForTopic = (alarms || []).filter(value => {
        return topic.ids.includes(value.signalId) && !value.acknowledged;
      });

      acknowledgeAlarms(alarmsForTopic.map(value => value._id));
    }

    onClose();
  };

  return (
    <Modal show={!!topic} size={'lg'} onBackdropClick={close} onHide={close}>
      <ModalHeader>
        <div className={'d-flex w-100 justify-content-between align-items-center'}>
          <div className={'h3'}>
            <span>{topic?.text}</span>
          </div>
          <Button onClick={close} variant={'warning'}>
            Close
          </Button>
        </div>
      </ModalHeader>

      <ModalBody>
        {topic && (
          <Row>
            <Col md={'6'}>
              <h5>Summary:</h5>
              <pre className={'text-break'} style={{ whiteSpace: 'pre-wrap' }}>
                {topic.context}
              </pre>
            </Col>
            <Col>
              <h5>Sources:</h5>

              {loading && (
                <div className={'m-5'}>
                  <Loading />
                </div>
              )}

              {sources?.content.map(value => (
                <div className={'small mb-3'}>
                  <MarketSignalScrollerEntry signal={value} />
                </div>
              ))}
            </Col>
          </Row>
        )}
      </ModalBody>
    </Modal>
  );
}
